export default __webpack_public_path__ + "static/media/fanm_dobout.111f036b.jpg";